import React, { Component } from 'react'
import ModalSearch from './ModalSearch'

class BigModal extends Component {
  render () {
    return (
      <div className='modal fade in' style={{display: (this.props.isOpen ? 'block' : 'none')}}>
        <div className='modal-backdrop' onClick={e => this.props.close.call()}>
          <div className='modal-dialog big-modal-dialog' onClick={e => e.stopPropagation()}>
            <div className={'modal-content big-modal-content ' + (this.props.noOverflow && 'no-overflow')}>
              <div className='modal-header'>
                <button type='button' className='close' onClick={(e) => this.props.close.call()}><span>&times;</span></button>
                <h4 className='modal-title'>{this.props.icon && <i className={'fa fa-fw fa-' + this.props.icon} />} {this.props.title}</h4>
                <ModalSearch filter={this.props.filter} />
              </div>
              <div className={'modal-body big-modal-body ' + this.props.className}>
                {this.props.children}
              </div>
              <div className={(this.props.nofooter ? 'hidden' : 'modal-footer big-modal-footer')}>
                {this.props.buttons && this.props.buttons.map((button) => {
                  if (button.hidden) return null
                  return (
                    <a key={Date.now() + Math.random()} onClick={button.event} className='modal-button'>{button.text}</a>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default BigModal



// WEBPACK FOOTER //
// ./src/components/basic/containers/BigModal.js